export const userPermissionsList = {
    referenceBooks: {
        reasonsPersonalAccountTransactions: {
            control: "reasonsPersonalAccountTransactionsControl",
        },
        medicalAnalyses: {
            control: "medicalAnalysisControl",
        },
        workSchedules: {
            viewAll: "manageWorkSchedulesAll",
            view: "manageWorkSchedules",
        },
        dismissalReasons: {
            control: "dismissControl",
        },
        reasonsForRejectCandidate: {
            control: "candidateRefusalControl",
        },
        workerCandidatesStatuses: {
            control: "workerStatusControl",
        },
        foulsTypes: {
            control: "foulTypesControl",
        },
        finesAndBonuses: {
            view: "viewBonusPenaltyFilial",
            viewAll: "viewBonusPenalty",
            edit: "editBonusFilial",
            editAll: "editBonus",
            createFromCalc: "createFineAndBonusReasonFromCalc",
        },
        holidaySurcharges: {
            control: "surchargeControl",
        },
        uniform: {
            control: "uniformControl",
        },
        uniformItems: {
            control: "inventoryControl",
            delete: "inventoryControlDelete",
        },
        moneySource: {
            control: "moneySourcesControl",
        },
        moneyTransaction: {
            control: "moneyTransactionControl",
        },
        competencies: {
            control: "updateCompetencies",
        }
    },
    worker: {
        medicalAnalyses: {
            view: "viewWorkerMedicalAnalysis",
            control: "controlWorkerMedicalAnalysis",
        },
        documents: {
            view: "viewWorkerDocuments",
            control: "updateWorkerDocuments",
            own: "viewOwnDocuments",
        },
        worksheet: {
            view: "viewWorkerWorksheet",
            control: "updateWorkerWorksheet",
        },
        comment: {
            view: "viewWorkerComment",
            edit: "updateWorkerComment",
        },
        transactions: {
            remove: "deletePersonalTransfer",
            restore: "viewAndRecoverDeletedPersonalTransfer",
        },
        profile: {
            view: "viewWorkerWorksheet",
            edit: "updateWorkerWorksheet",
        },
        viewAll: "workerView",
        viewOwn: "workerViewFilial",
        controlAll: "workerControl",
        controlOwn: "workerControlFilial",
        viewSummaryData: "viewWorkerSummaryData",
    },
    reports: {
        medicalAnalyses: {
            all: "viewReportMedicalAnalysesAll",
            own: "viewReportMedicalAnalyses",
        },
        courier: {
            own: "viewCourierReport",
            all: "viewCourierReportAll",
        },
        violations: {
            all: "foulControlReportAll",
            own: "foulControlReport",
        },
        finesAndBonuses: {
            own: "viewOwnBonusFineReports",
            all: "viewAllBonusFineReports",
        },
        olap: {
            calc: "viewOlapCalcsReport",
            worker: "viewOlapWorkersReport",
        },
    },
    staff: {
        candidates: {
            own: "viewCandidates",
            all: "viewCandidatesForAllFilials",
        },
        candidate: {
            edit: "updateWorksheet",
        },
    },
    violations: {
        control: "foulControl",
    },
    profiles: {
        control: "updateQuest",
    },
    financialTransaction: {
        all: "financeTransactionAllFilials",
        own: "financeTransactionManagement",
    },
    calculationSheet: {
        all: "calculationSheetAllFilials",
        own: "calculationSheetManagement",
    },
    closeCalculation: {
        all: "closeCalculation",
        own: "closeCalculationFilial",
    },
    educationalMaterials: {
        all: "educationalMaterialControl",
    },
};
